// servicesData.js
const services = [
    {
      icon: "/publicImages/iconhome1.png",
      id:"1",
      title: "Conseil & Fusions-Acquisitions",
      details:  [
       "Accompagnement stratégique pour la croissance, les investissements et les restructurations"
      ],
      detailData: {
        id:"1",
        title: "Conseil & Fusions-Acquisitions",
        subtitle: "Avec plus de 25 ans d’expérience dans la finance internationale, le conseil et les transactions transfrontalières, notre fondateur a accompagné des projets stratégiques dans de nombreuses régions du monde. StratEdge met cette expertise au service de votre entreprise pour créer de la valeur à chaque étape du cycle de vie des opérations.",
        sections: [
          {  image: "/publicImages/service 1.png", 
          points: [
            ] },
          { image: "/publicImages/service 2.png", points: [

       ] },
          { image: "/publicImages/service 3.png", points: [
        
          ] },
        ]
      }
    },
    {
      icon: "/publicImages/iconhome2.png",
      id:"2",
      title: "Outsourcing",
      details: [
       "Services BPO clés en main dans les domaines de la finance, de l’audit, des ressources humaines et du support informatique"
      ],
      detailData: {
        id:"2",
        title: "Outsourcing",
        subtitle: "Services BPO B2B clés en main",
        sections: [
          { title: "OFFRE", image: "/images/offre.png", points: [
            "StratEdge s’associe à des partenaires soigneusement sélectionnés pour offrir aux cabinets comptables européennes en croissance des solutions opérationnelles nearshore rentables.  Nous agissons comme une plateforme stratégique — en fournissant non seulement une réduction des coûts de main-d'œuvre, mais aussi des solutions intégralement gérées.\n\n",
            "Contact : Contact@stratEdgeos.lu \n\n",
            "Plus d’informations sur le site de notre partenaire :My Outsourcing www.my-outsourcing.com",
            ] },
        ]
      }
    },
    {
      icon: "/publicImages/iconhome3.png",
      id:"3",
      title: "Centre d'appels",
      details: [
        "Services clients multilingues ",
      ],
      detailData: {
        id:"3",
        title: "Services Clients & Centre d’Appels",
        subtitle: "Public cible : Particuliers, PME en Europe",
        sections: [
          {  image: "/publicImages/service proposés.png", points: [
            
           
          ] },
          { image:"/publicImages/caractiristique.png", points: [
           
          ] },
        ]
      }
    },
  ];
  
  export default services;
  